var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(5 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 12,
    height: 12,
    transform: "translate(12) rotate(90)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M10.114,11.884a.52.52,0,0,1-.239-.057L7.221,10.438,4.567,11.827a.52.52,0,0,1-.754-.552l.52-2.929L2.189,6.265a.512.512,0,0,1,.291-.874l2.966-.432L6.752,2.289a.52.52,0,0,1,.937,0L9.011,4.953l2.966.432a.512.512,0,0,1,.291.874L10.124,8.341l.52,2.929a.515.515,0,0,1-.531.614Z",
    transform: "translate(-0.977 -0.957)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageStar);
export default __webpack_public_path__ + "static/media/MessageStar.0b02b5ded64f3bca2b8dc4ee2ec01fa4.svg";
export { ForwardRef as ReactComponent };